import React, { Component } from 'react';
import "./tuitionlist.css"
import TimeAgo from 'react-timeago'
class Notices extends Component {
  render() {
    

    return (
        
        
           
                             
          <div>                 
            <div className="aticle-body-dash-notice">  
                <div className="aticle-sub">  
                    <p className="aticle-date"> <TimeAgo date={this.props.date}/> </p>
                    <i className="fas fa-user-tie icon-link"></i> {this.props.name}
                </div>

                
                <div className="notice-title-body-head">  <p>{this.props.title}</p></div>
                <p>  
                    {this.props.body}
                </p>
                <br/>
                
            </div>
             {/* <div className="dashnotice-underline"> </div> */}
           </div>                   
                                
                               
                                 
              

    )

}





}

export default Notices;


// WEBPACK FOOTER //
// ./src/component/dashboard/notices.js